<template>
  <ValuationTool />
</template>

<script setup>
import ValuationTool from "@/components/common/ValuationTool.vue"
</script>
